<div class="circular-progress" [ngClass]="customClass" [ngStyle]="getStyle()">
  <svg [attr.width]="size" [attr.height]="size" [attr.viewBox]="'0 0 ' + size + ' ' + size" class="cp-svg">
    <g>
      <circle
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="radius"
        [attr.stroke]="baseColor"
        [attr.stroke-width]="thickness"
        fill="none"
        class="cp-bg"
      ></circle>

      <circle
        class="cp-progress"
        [attr.cx]="size / 2"
        [attr.cy]="size / 2"
        [attr.r]="radius"
        [attr.stroke]="fillColor"
        [attr.stroke-width]="thickness"
        fill="none"
        [attr.stroke-dasharray]="circumference + ' ' + circumference"
        [attr.stroke-dashoffset]="strokeDashoffset"
        [attr.transform]="'rotate(-90 ' + size / 2 + ' ' + size / 2 + ')'"
      ></circle>
    </g>
  </svg>

  <div class="cp-center" [style.fontSize.px]="centerFontSize">
    @if (showPercentage) {
      <span class="cp-perc">{{ percentage }}%</span>
    }
  </div>
</div>
